import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DialogContent, Action } from 'models/Dialog/type';

export interface DialogState {
  shown: boolean;
  content: string;
  title?: string;
  defaultAction?: Action;
  cancelAction?: Action;
}

const initialState: DialogState = {
  shown: false,
  content: '',
  title: undefined,
  defaultAction: undefined,
  cancelAction: undefined,
};

const slice = createSlice({
  name: 'dialog',
  initialState,
  reducers: {
    showDialog: (state, action: PayloadAction<DialogContent>): DialogState => ({
      ...state,
      shown: true,
      content: action.payload.content,
      title: action.payload.title,
      defaultAction: action.payload.defaultAction,
      cancelAction: action.payload.cancelAction,
    }),
    closeDialog: (state): DialogState => ({
      ...state,
      shown: false,
      content: '',
      title: undefined,
      defaultAction: undefined,
      cancelAction: undefined,
    }),
  },
});

export const dialogReducer = slice.reducer;
export const { showDialog, closeDialog } = slice.actions;
